import { Map, List } from 'immutable'
import _map from 'lodash/map'
import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { EN } from '../languages/constants'
import { getUserLanguagePrimary } from '../user/index'
import { getAuthIsLoggedIn } from '../auth/index'
import {
  getFeaturedEpisodeUserNodeInfo,
  getUserNodeInfoVideoMediaData,
  getMultiplePmUserNodeInfo,
} from '../user-node-info/actions'
import { addNewRelicAction } from '../app/_newrelic'
import { getPrimary } from '../languages/index'
import {
  TERM_KEY,
  ACTIONS_SETTINGS_KEY,
} from './entities'
import {
  GET_PM_MULTIPLE_NODES,
  NODES_RECIEVED,
  nodesRecieved,
} from './actions'
import {
  fetchMultipleNodes as apiGetNodes,
  fetchMultipleTerms as apiGetTerms,
} from './api'
import { isValidNodeId, getSafeNodeId } from './utils'

export function fetchMultipleNodesWatcher ({ after }) {
  return after(GET_PM_MULTIPLE_NODES, async ({ action, state, dispatch }) => {
    const {
      user = Map(),
      auth = Map(),
      node = Map(),
    } = state
    const {
      payload: {
        ids,
        key,
        language = getUserLanguagePrimary(user) || EN,
        [ACTIONS_SETTINGS_KEY]: settings,
        // [aburtsev] below is the migragion of hack
        /*
         * fetchAsNodes is a temporary mechanism to switch
         * from using the `/term` endpoint to `/node`
         * The node data structure is our current means of serving content.
         * This gives us access to some data `/term` did not provide.
         * Eventually the plan is to migrate away from `/term` entirely
         * but for now this allows us to still allow pm-lists that use terms
         * to leverage the term part of the store and related code, but with the benefit
         * of the newer 'node' data type.
         */
        fetchAsNodes = false,
        contentType,
        preventNodeFetch,
      },
    } = action
    const primaryLang = getPrimary(user.getIn(['data', 'language'], List()))
    // TODO remove this conditionals. It's needed only for safe resolve merge conflicts
    let nodes

    // If we are preventing node data from loading (for graphql)
    if (preventNodeFetch) {
      // create fake node data so member home loads properly
      nodes = _reduce(ids, (acc, i) => {
        // we have to check to see if the video or series data already exists
        // otherwise we could have a blank spotlight, etc.
        const videoData = node.getIn(['video', getSafeNodeId(i), primaryLang, 'data'], Map()) || Map()
        const seriesData = node.getIn(['series', getSafeNodeId(i), primaryLang, 'data'], Map()) || Map()
        let data = {}

        if (videoData.size) {
          data = videoData.toJS()
        }

        if (seriesData.size) {
          data = seriesData.toJS()
        }

        acc.push({ id: i, data })
        return acc
      }, [])

      dispatch(nodesRecieved({ key, nodes, language }))
      return
    }

    if (key === TERM_KEY) {
      if (fetchAsNodes) {
        nodes = await apiGetNodes(
          {
            ids,
            language,
            auth,
            contentType,
          },
          settings,
        )
      } else {
        nodes = await apiGetTerms(
          {
            ids,
            language,
            auth,
          },
          settings,
        )
      }
    } else {
      nodes = await apiGetNodes(
        {
          ids,
          language,
          auth,
        },
        settings,
      )
    }

    if (getAuthIsLoggedIn(auth)) {
      dispatch(getMultiplePmUserNodeInfo(ids))
      // when we are getting series nodes, we also need to grab the featured episode info now
      // so that we can show the continue watching episode (all series tiles should going forward)
      // IMO this should be refactored to happen in brooklyn and come back with the batchget req
      // but apps is already using this secondary endpoint so we are going with this implementation
      // for now
      if (key === 'series') {
        dispatch(getFeaturedEpisodeUserNodeInfo(ids))
      }

      // when we are getting the video/episode nodes, we need to grab the media data as well
      if (key === 'video') {
        const nodeMediaData = _map(nodes, (n) => {
          return {
            id: _get(n, ['data', 'nid'], null),
            mediaId: _get(n, ['data', 'feature', 'nid'], null),
          }
        })

        dispatch(getUserNodeInfoVideoMediaData(nodeMediaData))
      }
    }

    dispatch(nodesRecieved({ key, nodes, language }))
  })
}

export function watchInvalidNodeRecieved ({ after }) {
  return after(NODES_RECIEVED, ({ action }) => {
    const { nodes, language } = action.payload
    nodes.forEach((node) => {
      const nodeId = node.id
      if (!isValidNodeId(nodeId)) {
        addNewRelicAction('InvalidNodeRecieved', {
          recievedId: nodeId,
          language,
          msg: 'node should contain valid id',
        })
      }
    })
  })
}
